export default {
  geolocation: {
    lat: '-33.469179',
    lng: '-70.642380',
    label: '8320000 Santiago',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
